import React from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import SettingsRadioGroup from '@/components/RadioGroup/SettingsRadioGroup';
import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import NoHolderBanner from '@/containers/DevicesPage/components/DeviceSettings/components/NoHolderBanner/NoHolderBanner';

import DeviceSettingLayout from '../../components/DeviceSettingLayout/DeviceSettingLayout';
import useDeviceSettingHolderGuard from '../../hooks/useDeviceSettingHolderGuard';
import {useIlluminationMode} from './useIlluminationMode';

const IlluminationModeSetting = () => {
    const {content, value, onChange, onSave} = useIlluminationMode();
    const {shouldShowNoHolderBanner, shouldDisableInputs, shouldDisableSaveButton, onDisabledSaveClick} =
        useDeviceSettingHolderGuard(AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE);

    if (!content) return null;

    const {popup, popupCurrentValue} = content;
    const {icon} = popupCurrentValue || {};
    const {description, title, connectButton, primaryButton} = popup || {};

    const options = popup?.groups?.values.map((item) => ({
        value: item.type,
        label: item.icon?.title,
        ariaLabel: item.ariaLabel,
        icon: <RemoteIconV2 icon={item.icon} />,
    }));

    return (
        <DeviceSettingLayout
            footer={
                <DeviceSettingLayout.ConnectButtonContainer
                    connectButton={connectButton}
                    primaryButton={primaryButton}
                    onPrimaryButtonClick={onSave}
                    isDisabled={shouldDisableSaveButton}
                    onDisableClick={onDisabledSaveClick}
                />
            }
        >
            <DeviceSettingLayout.Header icon={icon} title={title} description={description} />
            {shouldShowNoHolderBanner && <NoHolderBanner className='mt-4' />}
            <DeviceSettingLayout.ControlsContainer>
                <SettingsRadioGroup
                    options={options}
                    value={value}
                    onValueChange={onChange}
                    isDisabled={shouldDisableInputs}
                    onDisableClick={onDisabledSaveClick}
                />
            </DeviceSettingLayout.ControlsContainer>
        </DeviceSettingLayout>
    );
};

export default IlluminationModeSetting;
